import React, { useEffect, useState } from 'react'
import './AdminGameResults.css'
import AdminNavigation from './AdminNavigation'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'

const AdminGameResultsChampionship = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [homeTeamName, setHomeTeamName] = useState()
	const [visitorTeamName, setVisitorTeamName] = useState()
	const [championshipGameStats, setChampionshipGameStats] = useState([])
	const [homeGoalieDropdown, setHomeGoalieDropdown] = useState([])
	const [visitorGoalieDropdown, setVisitorGoalieDropdown] = useState([])
	const [dayOfWeek, setDayOfWeek] = useState()
	const [date, setDate] = useState()
	const [time, setTime] = useState()
	const [venue, setVenue] = useState()
	const [leagueName, setLeagueName] = useState()
	const [homeGoalies, setHomeGoalies] = useState()
	const [visitorGoalies, setVisitorGoalies] = useState()
	const [homeGoalieRosterPlayerId, setHomeGoalieRosterPlayerId] = useState()
	const [homeGoalieName, setHomeGoalieName] = useState()
	const [visitorGoalieRosterPlayerId, setVisitorGoalieRosterPlayerId] =
		useState()
	const [visitorGoalieName, setVisitorGoalieName] = useState()
	const gameId = useParams().gameId

	//Here, I want to go to the backend, using the championshipGameId (or gameId??), to get the
	//game date, time, venue, home team, and visitor team.
	//If stats already exist for this championship game (like, we needed to edit the score),
	//we'll get that information as well.
	//getGameRostersAndPointsPerPeriod in admin-controller.js
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${gameId}/rostersAndPoints`
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}
				setHomeTeamName(responseData.homeTeamName)
				setVisitorTeamName(responseData.visitorTeamName)
				setChampionshipGameStats(responseData.gameStats)
				setDayOfWeek(responseData.dayOfWeek)
				setDate(responseData.date)
				setTime(responseData.time)
				setVenue(responseData.venue)
				setLeagueName(responseData.leagueName)
				setHomeGoalies(responseData.homeGoalies)
				setVisitorGoalies(responseData.visitorGoalies)
				//
				//
				//
				let homeGoalieDropdownArray
				homeGoalieDropdownArray = []
				if (responseData.homeGoalies) {
					responseData.homeGoalies.forEach((goalie) => {
						homeGoalieDropdownArray.push(
							goalie.firstName + ' ' + goalie.lastName
						)
					})
					setHomeGoalieDropdown(homeGoalieDropdownArray)
				}
				//
				//
				let visitorGoalieDropdownArray
				visitorGoalieDropdownArray = []
				if (responseData.visitorGoalies) {
					responseData.visitorGoalies.forEach((goalie) => {
						visitorGoalieDropdownArray.push(
							goalie.firstName + ' ' + goalie.lastName
						)
					})
					setVisitorGoalieDropdown(visitorGoalieDropdownArray)
				}
				//
				//
				setIsLoading(false)
			} catch (err) {
				setError(err)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [gameId])

	console.log('championshipGameStats: ' + JSON.stringify(championshipGameStats))

	let homePointsTotal,
		visitorPointsTotal,
		status,
		summary,
		score,
		prevHomeGoalieRosterPlayerId,
		prevVisitorGoalieRosterPlayerId
	if (championshipGameStats) {
		if (championshipGameStats.length > 0) {
			console.log('WE HAVE PREVIOUS STATS from this championship game')
			console.log(
				'championshipGameStats: ' + JSON.stringify(championshipGameStats)
			)
			homePointsTotal = championshipGameStats[0].homeGoalsTotal
			visitorPointsTotal = championshipGameStats[0].visitorGoalsTotal
			status = championshipGameStats[0].status
			summary = championshipGameStats[0].summary
			console.log('summary here: ' + summary)
			console.log('homeGoalsTotal here: ' + homePointsTotal)
			prevHomeGoalieRosterPlayerId =
				championshipGameStats[0].homeGoalieRosterPlayerId
			prevVisitorGoalieRosterPlayerId =
				championshipGameStats[0].visitorGoalieRosterPlayerId
		}
	} else {
		console.log('NO GAME STATS YET!!!')
	}
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	//
	if (!isLoading) {
		if (prevHomeGoalieRosterPlayerId) {
			console.log('WE HAVE A PREVIOUS GOALIE for the HOME team')
		} else {
			console.log('no prev home goalie')
		}
		//
		//
		if (prevVisitorGoalieRosterPlayerId) {
			console.log('WE HAVE A PREVIOUS GOALIE for the VISITOR team')
		} else {
			console.log('no prev visitor goalie')
		}
	}
	//
	//
	//**************************************** */
	//
	//  home team goalie stuff
	//
	//**************************************** */
	//
	//
	let gamehomegoalie
	const handleHomeGoalie = (e) => {
		console.log(e.target.value)
		gamehomegoalie = document.getElementById('homeGoalie').value
		console.log('todays goalie for HOME team: ' + gamehomegoalie)
		const split = gamehomegoalie.split(' ')
		const firstname = split[0]
		const lastname = split[1]
		let homeGoalieRosterPlayerId
		homeGoalies.forEach((goalie) => {
			if (goalie.firstName === firstname && goalie.lastName === lastname) {
				console.log('We have a match: ' + goalie.firstName)
				homeGoalieRosterPlayerId = goalie._id
			}
		})
		console.log('homeGoalieRosterPlayerId: ' + homeGoalieRosterPlayerId)
		setHomeGoalieRosterPlayerId(homeGoalieRosterPlayerId)
		setHomeGoalieName(gamehomegoalie)
	}
	//
	//NOT DOING SHOTS AGAINS FOR COOL HOCKEY EVENTS
	/* let shotsagainst
	const handleShotsAgainst = (e) => {
		shotsagainst = document.getElementById('shotsAgainst').value
		setNewShotsAgainst(shotsagainst)
	} */
	//
	//
	let prevHomeGoalieName
	//
	if (prevHomeGoalieRosterPlayerId && homeGoalies) {
		homeGoalies.forEach((goalie) => {
			if (goalie._id === prevHomeGoalieRosterPlayerId) {
				prevHomeGoalieName = goalie.firstName + ' ' + goalie.lastName
			}
		})
	}
	//
	//
	//
	//**************************************** */
	//
	//  visitor team goalie stuff
	//
	//**************************************** */
	//
	//
	let gamevisitorgoalie
	const handleVisitorGoalie = (e) => {
		console.log(e.target.value)
		gamevisitorgoalie = document.getElementById('visitorGoalie').value
		console.log('todays goalie for VISITOR team: ' + gamevisitorgoalie)
		const split = gamevisitorgoalie.split(' ')
		const firstname = split[0]
		const lastname = split[1]
		let visitorGoalieRosterPlayerId
		visitorGoalies.forEach((goalie) => {
			if (goalie.firstName === firstname && goalie.lastName === lastname) {
				console.log('We have a match: ' + goalie.firstName)
				visitorGoalieRosterPlayerId = goalie._id
			}
		})
		//GoalieRosterPlayerId: ' + visitorGoalieRosterPlayerId)
		setVisitorGoalieRosterPlayerId(visitorGoalieRosterPlayerId)
		setVisitorGoalieName(gamevisitorgoalie)
	}
	//
	//NOT DOING SHOTS AGAINS FOR COOL HOCKEY EVENTS
	/* let shotsagainst
	const handleShotsAgainst = (e) => {
		shotsagainst = document.getElementById('shotsAgainst').value
		setNewShotsAgainst(shotsagainst)
	} */
	//
	//
	let prevVisitorGoalieName
	//
	if (prevVisitorGoalieRosterPlayerId && visitorGoalies) {
		visitorGoalies.forEach((goalie) => {
			if (goalie._id === prevVisitorGoalieRosterPlayerId) {
				prevVisitorGoalieName = goalie.firstName + ' ' + goalie.lastName
			}
		})
	}
	//
	//
	//
	let navigate = useNavigate()
	//Here, I want to tap into the backend and update stats for the game and rosterPlayers
	//Maybe...or maybe I want to do it another way...
	const logChampionshipGameStats = async () => {
		if (!homeGoalieName || !visitorGoalieName) {
			alert('Please make sure you select a Goalie for BOTH teams!')
		} else {
			const gameSummary = document.getElementById('gameSummary').value
			const homePointsTotal = document.getElementById('homeGoalsTotal').value
			const visitorPointsTotal =
				document.getElementById('visitorGoalsTotal').value
			//**************************************************** */
			//
			//  Game stats:
			//
			//***************************************************** */
			try {
				//tapping into backend to add championship game stats...
				// admin-controller    createchampionshipGameStats
				setIsLoading(true)
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/championshipGameStats/${gameId}`,
					{
						method: 'PATCH',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							homePointsTotal,
							visitorPointsTotal,
							gameSummary,
							homeGoalieName,
							homeGoalieRosterPlayerId,
							visitorGoalieName,
							visitorGoalieRosterPlayerId,
							gameId,
						}),
					}
				)
				const responseData = await response.json()
				if (!response.ok) {
					throw new Error(responseData.message)
				}
				setIsLoading(false)
				//navigate('/admin/masterSchedule')
				navigate(-1)
			} catch (err) {
				console.log('error: ' + err)
				setIsLoading(false)
				setError(
					err.message ||
						'Something went wrong with adding championship game stats'
				)
			}
		}
	}
	//
	//
	//
	//
	return (
		<React.Fragment>
			<AdminNavigation />
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<span>
				<h1 style={{ marginTop: '5rem' }}>
					<h1 style={{ color: 'red', fontWeight: 'bold' }}>
						CHAMPIONSHIP GAME!
					</h1>{' '}
					{homeTeamName} vs. {visitorTeamName}
				</h1>
				<p style={{ textAlign: 'center' }}>
					{dayOfWeek},{' '}
					{date && date.substr(0, 2) === '01' && 'Jan. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '02' && 'Feb. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '03' && 'Mar. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '04' && 'Apr. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '05' && 'May ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '06' && 'June ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '07' && 'July ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '08' && 'Aug. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '09' && 'Sept. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '10' && 'Oct. ' + date.substr(3, 2)}
					{date && date.substr(0, 2) === '11' && 'Nov. ' + date.substr(3, 2)}
					{date &&
						date.substr(0, 2) === '12' &&
						'Dec. ' + date.substr(3, 2)},{' '}
					{time &&
						time.substr(0, 2) === '01' &&
						'1:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '02' &&
						'2:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '03' &&
						'3:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '04' &&
						'4:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '05' &&
						'5:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '06' &&
						'6:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '07' &&
						'7:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '08' &&
						'8:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '09' &&
						'9:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '10' &&
						'10:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '11' &&
						'11:' + time.substr(3, 2) + ' am'}
					{time &&
						time.substr(0, 2) === '12' &&
						'12:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '13' &&
						'1:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '14' &&
						'2:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '15' &&
						'3:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '16' &&
						'4:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '17' &&
						'5:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '18' &&
						'6:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '19' &&
						'7:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '20' &&
						'8:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '21' &&
						'9:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '22' &&
						'10:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '23' &&
						'11:' + time.substr(3, 2) + ' pm'}
					{time &&
						time.substr(0, 2) === '24' &&
						'12:' + time.substr(3, 2) + ' am'}
					, {venue}
				</p>
			</span>
			<div className='row'>
				<div className='col-sm'></div>
				<div className='col-sm'></div>
			</div>

			<div className='row' style={{ paddingBottom: '2rem' }}>
				{/* <div className='col-sm'></div> */}
				<div className='col-sm gameSummary'>
					{/* <label for='textarea'>GAME SUMMARY:</label> */}
					<textarea
						className='summaryTextArea'
						id='gameSummary'
						defaultValue={summary}
						placeholder='Good game?  Write something about it...'
						rows='2'
						cols='35'
					></textarea>
				</div>
				{/* <div className='col-sm'></div> */}
			</div>

			<table className='AdminRoster' id='adminPlayoffRoster'>
				<thead>
					<tr>
						<th>Team</th>
						<th>Final</th>
					</tr>
				</thead>
				<tbody>
					<tr style={{ height: '5px' }}>
						<td className='playoffTeamName'>{homeTeamName}</td>
						<td>
							<input
								id='homeGoalsTotal'
								type='number'
								min='0'
								max='99'
								defaultValue={homePointsTotal}
							/>
						</td>
					</tr>
					<tr>
						<td className='playoffTeamName'>{visitorTeamName}</td>
						<td>
							<input
								id='visitorGoalsTotal'
								type='number'
								min='0'
								max='99'
								defaultValue={visitorPointsTotal}
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<div className='row' style={{ marginTop: '2rem' }}>
				{/* <div className='col-sm'></div> */}
				<div className='col-sm'></div>
				<div className='col-sm gameStatus' style={{ fontSize: 'small' }}>
					{homeTeamName} GOALIE:
					<select
						required
						id='homeGoalie'
						className='listOfPenalties dropdownElement'
						onChange={handleHomeGoalie}
						style={{ backgroundColor: 'white', width: 'auto' }}
					>
						{/* <option defaultValue>
							{(prevHomeGoalieName && prevHomeGoalieName) ||
								'Select a goalie...'}
							Select a goalie...
						</option> */}
						<option defaultValue>{prevHomeGoalieName}</option>
						{homeGoalieDropdown.map((goalie, i) => (
							<option value={goalie} key={i}>
								{goalie.toUpperCase()}
							</option>
						))}
						<option>Someone else</option>
					</select>
				</div>
				<div className='col-sm'></div>
			</div>
			<div className='row' style={{ marginTop: '2rem' }}>
				{/* <div className='col-sm'></div> */}
				<div className='col-sm'></div>
				<div className='col-sm gameStatus' style={{ fontSize: 'small' }}>
					{visitorTeamName} GOALIE:
					<select
						required
						id='visitorGoalie'
						className='listOfPenalties dropdownElement'
						onChange={handleVisitorGoalie}
						style={{ backgroundColor: 'white', width: 'auto' }}
					>
						{/* <option defaultValue>
							{(prevVisitorGoalieName && prevVisitorGoalieName) ||
								'Select a goalie...'}
							Select a goalie...
						</option> */}
						<option defaultValue>{prevVisitorGoalieName}</option>
						{visitorGoalieDropdown.map((goalie, i) => (
							<option value={goalie} key={i}>
								{goalie.toUpperCase()}
							</option>
						))}
						<option>Someone else</option>
					</select>
				</div>
				<div className='col-sm'></div>
			</div>
			<div
				className='col-sm'
				style={{
					// width: '7%',
					marginLeft: 'auto',
					marginRight: 'auto',
					display: 'block',
					paddingTop: '3%',
					marginBottom: '10rem',
					textAlign: 'center',
				}}
			>
				<AdminButton onClick={logChampionshipGameStats}>SAVE</AdminButton>
			</div>
		</React.Fragment>
	)
}

export default AdminGameResultsChampionship
